/**
 * InputPassword Component - Constants
 * ===================================
 */

import { getIcon } from '../../icons';

export type InputPasswordSize = 'sm' | 'md';

export interface InputPasswordSizeStyles {
  control: string;
  text: string;
  icon: string;
}

export interface InputPasswordDefaultValues {
  size: InputPasswordSize;
}

// Los tamaños md/sm mapean a L/M de Figma: solo cambia el padding del campo.
// Texto (16px) e ícono (24px) son fijos en ambos tamaños por spec.
export const SIZES: Record<InputPasswordSize, InputPasswordSizeStyles> = {
  sm: { control: 'ec-px-3 ec-py-2', text: 'ec-text-base', icon: 'ec-w-6 ec-h-6' },
  md: { control: 'ec-px-4 ec-py-3', text: 'ec-text-base', icon: 'ec-w-6 ec-h-6' }
};

export const BASE_CLASSES = {
  control:
    'ec-flex ec-items-center ec-gap-2 ec-bg-color-surface ' +
    'ec-rounded-lg ec-transition-colors focus-within:ec-ring-1 focus-within:ec-ring-color-primary',
  controlDisabled: 'ec-bg-color-bg ec-cursor-not-allowed',
  // Valor/placeholder en SF Mono (ec-font-numbers) — a diferencia de InputText.
  input:
    'ec-flex-1 ec-w-full ec-bg-transparent ec-outline-none ec-font-numbers ec-font-medium ' +
    'placeholder:ec-text-color-text-muted',
  // Colores del texto del input: mutuamente excluyentes (nunca combinar dos).
  inputColor: 'ec-text-color-text',
  inputError: 'ec-text-color-text-danger',
  inputDisabled: 'ec-text-color-text-muted ec-cursor-not-allowed',
  label: 'ec-text-base ec-text-color-text-secondary',
  help: 'ec-text-caption ec-font-medium',
  // Colores del help: mutuamente excluyentes.
  helpColor: 'ec-text-color-text-secondary',
  helpError: 'ec-text-color-text-danger',
  toggle:
    'ec-flex-shrink-0 ec-flex ec-items-center ec-justify-center ec-bg-transparent ec-border-0 ec-p-0 ' +
    'ec-text-color-text-muted hover:ec-text-color-text ec-cursor-pointer ec-rounded ' +
    'focus-visible:ec-outline-none focus-visible:ec-ring-2 focus-visible:ec-ring-color-primary ' +
    'disabled:ec-cursor-not-allowed'
};

/**
 * Iconos SVG predefinidos
 *
 * Las keys públicas (icon="eye"/"eyeOff") se mantienen igual — cero breaking.
 * Los valores vienen del registro central (`src/icons`) vía los alias
 * semánticos `eye→show` y `eye-off→hide`.
 */
export const ICONS = {
  eye: getIcon('eye') || '',
  eyeOff: getIcon('eye-off') || ''
};

export const DEFAULTS: InputPasswordDefaultValues = { size: 'md' };
